export * from './lib/soaking-material-detail-view';
